export default ["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  // Now set up the states
  $stateProvider
    .state("periodicDownloadList", {
      parent: "app",
      url: "/periodicDownload?filterName&downloadFormat",
      feature: "menu.settings.periodicDownloads",
      views: {
        "main": {
          template: require("./eaPeriodicDownloadPage/eaPeriodicDownloadPageModule.html"),
          controller: "eaPeriodicDownloadPageModuleController as $ctrl"
        }
      },
      resolve: {
        ctrl: ["$q", "$ocLazyLoad", ($q, $ocLazyLoad)=> {
          return $q((resolve)=> {
            require.ensure([], ()=> {
              let module = require("./index.js");
              $ocLazyLoad.load({name: module.default});
              resolve();
            });
          });
        }],
      }
    });
}];



// WEBPACK FOOTER //
// ./src/ui/modules/eaSettings/eaPeriodicDownload/routes.js